import React from 'react';
import '../../styles/App.scss';
import '../../styles/Navbar.scss';

import {NavLink} from 'react-router-dom';
import Typography from '@mui/material/Typography';

//components
import SoundButtonPlayer from '../SoundButtonPlayer';

function NavbarTabs(){
    return(
        <>
            <div className="navbartabs">
                <NavLink to="/" className={({isActive}) =>isActive ? "nav-textbubble active" : "nav-textbubble"}>
                    <SoundButtonPlayer >
                        <Typography variant="body1" className='App-navbar-tab_txt'>
                            Home
                        </Typography>
                        
                    </SoundButtonPlayer>
                </NavLink>
                <NavLink to="/pages/Fiction" className={({isActive}) =>isActive ? "nav-textbubble active" : "nav-textbubble"}>
                    <SoundButtonPlayer>
                        <Typography variant="body1" className='App-navbar-tab_txt'>
                            Fiction
                        </Typography>
                        
                    </SoundButtonPlayer>
                </NavLink>
                <NavLink to="/pages/Fanfiction" className={({isActive}) =>isActive ? "nav-textbubble active" : "nav-textbubble"}>
                    <SoundButtonPlayer>
                        <Typography variant="body1" className='App-navbar-tab_txt'>
                            Fanfiction
                        </Typography>
                        
                    </SoundButtonPlayer>
                </NavLink>
                <NavLink to="/pages/Nonfiction" className={({isActive}) =>isActive ? "nav-textbubble active" : "nav-textbubble"}>
                    <SoundButtonPlayer> 
                        <Typography variant="body1" className='App-navbar-tab_txt'>
                            Nonfiction
                        </Typography>
                        
                    </SoundButtonPlayer>
                </NavLink>
                <NavLink to="/pages/About" className={({isActive}) =>isActive ? "nav-textbubble active" : "nav-textbubble"}>
                    <SoundButtonPlayer>
                        <Typography variant="body1" className='App-navbar-tab_txt'>
                            About
                        </Typography>
                        
                    </SoundButtonPlayer>
                </NavLink>
                <NavLink to="/pages/Contact" className={({isActive}) =>isActive ? "nav-textbubble active" : "nav-textbubble"}>
                    <SoundButtonPlayer>
                        <Typography variant="body1" className='App-navbar-tab_txt'>
                            Contact
                        </Typography>
                        
                    </SoundButtonPlayer>
                </NavLink>
                <NavLink to="/pages/Links" className={({isActive}) =>isActive ? "nav-textbubble active" : "nav-textbubble"}>
                    <SoundButtonPlayer>
                        <Typography variant="body1" className='App-navbar-tab_txt'>
                            Links
                        </Typography>
                        
                    </SoundButtonPlayer>
                </NavLink>
            </div>
        </>
    );
}

export default NavbarTabs;